import { Component, Inject, OnInit } from "@angular/core";
import { APP_SETTINGS, AppSettings } from "app/app.settings";

@Component({
    selector: "app-signout",
    templateUrl: "./signout.component.html",
    standalone: false
})
export class SignoutComponent implements OnInit {

    constructor(@Inject(APP_SETTINGS) private env: AppSettings) {}

    ngOnInit() {
        const url = sessionStorage.getItem("signoutRedirect");
        sessionStorage.removeItem("signoutRedirect");

        if (url && this.isAllowedRedirect(url))
            window.location.href = url;
        else
            window.location.href = "/";
    }

    private isAllowedRedirect(url: string): boolean {
        if (url.startsWith("/"))
            return true;
        try {
            const target = new URL(url);
            const authority = this.env.authConfig.authority;
            if (authority && url.startsWith(authority))
                return true;
            return target.origin === window.location.origin;
        } catch {
            return false;
        }
    }
}
